var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldProgramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6387 7.65444C72.5751 5.38176 77.4249 5.38176 81.3613 7.65444L130.142 35.8181C134.079 38.0908 136.504 42.2909 136.504 46.8363V103.164C136.504 107.709 134.079 111.909 130.142 114.182L81.3613 142.346C77.4249 144.618 72.5751 144.618 68.6387 142.346L19.8577 114.182C15.9213 111.909 13.4964 107.709 13.4964 103.164V46.8363C13.4964 42.2909 15.9213 38.0908 19.8577 35.8181L68.6387 7.65444Z",
    fill: "url(#paint0_linear_47_10039)",
    stroke: "url(#paint1_linear_47_10039)",
    strokeWidth: 6.89655
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0806 98.2759L60.3448 77.8035V72.9788H64.2568C65.8215 72.9788 67.1907 72.7615 68.3643 72.3269C69.5813 71.8487 70.581 71.175 71.3634 70.3057C72.1892 69.4364 72.7543 68.3932 73.0586 67.1762H60.3448V62.3515H72.9934C72.7326 61.2214 72.2762 60.2217 71.6242 59.3524C71.0157 58.483 70.1898 57.8093 69.1466 57.3312C68.1469 56.8096 66.9299 56.5488 65.4955 56.5488H60.3448V51.7241H89.7494V56.5488H79.5132C80.2521 57.3747 80.8606 58.2657 81.3388 59.222C81.8604 60.1782 82.2081 61.2214 82.3819 62.3515H89.7494V67.1762H82.5123C82.0777 70.3926 80.8389 72.9136 78.796 74.7392C76.7531 76.5213 74.1235 77.7383 70.907 78.3903L83.6859 98.2759H72.0806Z",
    fill: "url(#paint2_linear_47_10039)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_10039",
    x1: 75.0002,
    y1: -3.22716,
    x2: 75.0002,
    y2: 153.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#432E11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_10039",
    x1: -75.2427,
    y1: -23.0182,
    x2: 165.991,
    y2: -12.7411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CFAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_10039",
    x1: 36.7645,
    y1: 24.625,
    x2: 97.8631,
    y2: 25.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CFAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldProgramIcon);
export default __webpack_public_path__ + "static/media/goldProgramIcon.e39623f463e47c0ade52b1020e4d124d.svg";
export { ForwardRef as ReactComponent };